import { Avatar } from '@app/components'

export const TEMPLATE_CARD_DATA = [
  {
    icon: <Avatar size={'small'} />,
    description: 'Lorem ipsum dolor sit amet, consectetur adip iscing elit. Praesent euismod, leo ut vulpu',
    title: 'Template 1',
  },
  {
    icon: <Avatar size={'small'} />,
    description: 'Lorem ipsum dolor sit amet, consectetur adip iscing elit. Praesent euismod, leo ut vulpu',
    title: 'Template 1',
  },
  {
    icon: <Avatar size={'small'} />,
    description: 'Lorem ipsum dolor sit amet, consectetur adip iscing elit. Praesent euismod, leo ut vulpu',
    title: 'Template 1',
  },
]

export const TEMPLATE_CARD_LIST = [
  {
    icon: <Avatar size={'small'} />,
    title: 'Template 1 Lorem ispum text',
  },
  {
    icon: <Avatar size={'small'} />,
    title: 'Template 2 Lorem ispum',
  },
  {
    icon: <Avatar size={'small'} />,
    title: 'Template 3 Lorem ispum',
  },
]
